module.exports = __webpack_public_path__ + "img/logo-03.5f2a668d.png";